import { useMutation, useQueryClient } from '@tanstack/react-query'

import api from '../../api'
import type { TagDetailOption } from '../../api/tags/getTagDetails'

const TAG_DETAIL_NAME = 'platforms'

const usePlatformOptionsMutations = () => {
	const queryClient = useQueryClient()
	const refresh = () =>
		queryClient.invalidateQueries({ queryKey: ['tagDetails', TAG_DETAIL_NAME] })

	const create = useMutation({
		mutationFn: (option: TagDetailOption) =>
			api.tags.modifyTagDetailValue('PATCH', TAG_DETAIL_NAME, option),
		onSuccess: refresh
	})

	const remove = useMutation({
		mutationFn: (option: TagDetailOption) =>
			api.tags.modifyTagDetailValue('DELETE', TAG_DETAIL_NAME, option),
		onSuccess: refresh
	})

	const rename = useMutation({
		mutationFn: ({
			current,
			next
		}: {
			current: TagDetailOption
			next: TagDetailOption
		}) => api.tags.updateTagDetailValue(TAG_DETAIL_NAME, current, next),
		onSettled: refresh
	})

	return { create, remove, rename }
}

export default usePlatformOptionsMutations
